import { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'

import { AccountsGrid, Loader, SearchBar } from 'src/components'
import { ROUTES } from 'src/constants'
import { useAccounts } from 'src/hooks'
import { EAccountRoles } from 'src/types'

import { useStyles } from './styles'

const AccountsList = () => {
  const [t] = useTranslation()
  const [query, setQuery] = useState('')
  const { data: accounts, isLoading } = useAccounts({ query })
  const classes = useStyles()

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
  }

  if (
    accounts?.count === 1 &&
    !query &&
    accounts?.data?.[0]?.users?.[0].roles?.includes(EAccountRoles.scanner)
  ) {
    return (
      <Navigate to={joinAbsRoute(ROUTES.ACCOUNTS, accounts?.data?.[0].id, ROUTES.SCAN_HISTORY)} />
    )
  }

  return (
    <>
      <div className={classes.searchWrapper}>
        <SearchBar
          search={query}
          handleSearchChange={handleSearchChange}
          inputPlaceholder={t('accounts-search-input-placeholder.v')}
        />
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <AccountsGrid withAddition data={accounts?.data || []} withOptions showStatus />
      )}
    </>
  )
}

export { AccountsList }
